<template>
  <fwb-button v-bind="$props" :class="classes">
    <slot></slot>
  </fwb-button>
</template>

<script lang="ts" setup>
import { FwbButton } from 'flowbite-vue'
import { computed } from 'vue'

const props = defineProps({
  flat: {
    type: Boolean,
    default: false
  },

  link: {
    type: Boolean,
    default: false
  },

  secondary: {
    type: Boolean,
    default: false
  },

  icon: {
    type: Boolean,
    default: false
  },

  small: {
    type: Boolean,
    default: false
  },

  full: {
    type: Boolean,
    default: false
  },

  xsmall: {
    type: Boolean,
    default: false
  }
})

const classes = computed(() => {
  let result =
    'TwcButton bg-seastreak-action-blue hover:bg-seastreak-action-blue-light text-base focus:ring-0'

  if (props.small) {
    result = `${result} text-sm`
  }

  if (props.xsmall) {
    result = `${result} text-xs`
  }

  if (props.full) {
    result = `${result} w-full`
  }

  if (props.flat) {
    return `${result} border-0 bg-transparent text-gray-800 hover:bg-gray-200 focus:ring-0`
  }

  if (props.secondary) {
    return `${result} border border-black bg-white text-gray-800 hover:bg-gray-200 focus:ring-0`
  }

  if (props.icon) {
    return `${result} border bg-transparent text-gray-800 hover:bg-gray-200 p-2`
  }

  if (props.link) {
    return `${result} border-0 bg-transparent text-seastreak-action-blue hover:bg-seastreak-action-blue-light hover:bg-transparent p-0`
  }

  return result
})
</script>

<style scoped>
.TwcButton {
  touch-action: manipulation;
}
</style>
